var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.buttonLink ? _c('a', {
    staticClass: "seu-button",
    class: {
      'isLarge': _vm.isLarge,
      'isSmall': _vm.isSmall,
      'isTiny': _vm.isTiny
    },
    attrs: {
      "href": _vm.buttonLink,
      "target": _vm.target
    }
  }, [_vm.buttonIconBefore ? _c('span', {
    staticClass: "icon-container before"
  }, [_c('img', {
    attrs: {
      "src": _vm.buttonIconBefore,
      "alt": ""
    }
  })]) : _vm._e(), _c('span', {
    staticClass: "button-label caps-medium"
  }, [_vm._v(_vm._s(_vm.label))]), _vm.buttonIconAfter ? _c('span', {
    staticClass: "icon-container after"
  }, [_c('img', {
    attrs: {
      "src": _vm.buttonIconAfter,
      "alt": ""
    }
  })]) : _vm._e()]) : _vm.route ? _c('router-link', {
    staticClass: "seu-button",
    class: {
      'isLarge': _vm.isLarge,
      'isSmall': _vm.isSmall,
      'isTiny': _vm.isTiny
    },
    attrs: {
      "to": _vm.route,
      "target": _vm.target
    }
  }, [_vm.buttonIconBefore ? _c('span', {
    staticClass: "icon-container before"
  }, [_c('img', {
    attrs: {
      "src": _vm.buttonIconBefore,
      "alt": ""
    }
  })]) : _vm._e(), _c('span', {
    staticClass: "button-label caps-medium"
  }, [_vm._v(_vm._s(_vm.label))]), _vm.buttonIconAfter ? _c('span', {
    staticClass: "icon-container after"
  }, [_c('img', {
    attrs: {
      "src": _vm.buttonIconAfter,
      "alt": ""
    }
  })]) : _vm._e()]) : _c('button', {
    staticClass: "seu-button",
    class: {
      'isLarge': _vm.isLarge,
      'isSmall': _vm.isSmall,
      'isTiny': _vm.isTiny
    },
    on: {
      "click": function ($ev) {
        return _vm.$emit('click', $ev);
      }
    }
  }, [_vm.buttonIconBefore ? _c('span', {
    staticClass: "icon-container before"
  }, [_c('img', {
    attrs: {
      "src": _vm.buttonIconBefore,
      "alt": ""
    }
  })]) : _vm._e(), _c('span', {
    staticClass: "button-label caps-medium"
  }, [_vm._v(_vm._s(_vm.label))]), _vm.buttonIconAfter ? _c('span', {
    staticClass: "icon-container after"
  }, [_c('img', {
    attrs: {
      "src": _vm.buttonIconAfter,
      "alt": ""
    }
  })]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }